// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {PageBackground} from './page-background.js'
import {PageBookmarked} from './page-bookmarked.js'
import {SeqId} from './seq-id.js'

export class CreatePage {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): CreatePage {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsCreatePage(bb: flatbuffers.ByteBuffer, obj?: CreatePage): CreatePage {
    return (obj || new CreatePage()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsCreatePage(bb: flatbuffers.ByteBuffer, obj?: CreatePage): CreatePage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new CreatePage()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  location(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  background(obj?: PageBackground): PageBackground | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new PageBackground()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  pageCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 1
  }

  bookmarked(): PageBookmarked {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : PageBookmarked.Unbookmarked
  }

  static startCreatePage(builder: flatbuffers.Builder) {
    builder.startObject(4)
  }

  static addLocation(builder: flatbuffers.Builder, locationOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, locationOffset, 0)
  }

  static addBackground(builder: flatbuffers.Builder, backgroundOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, backgroundOffset, 0)
  }

  static addPageCount(builder: flatbuffers.Builder, pageCount: number) {
    builder.addFieldInt32(2, pageCount, 1)
  }

  static addBookmarked(builder: flatbuffers.Builder, bookmarked: PageBookmarked) {
    builder.addFieldInt8(3, bookmarked, PageBookmarked.Unbookmarked)
  }

  static endCreatePage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }
}
